import { Typography } from "antd";
import styles from "./index.module.less";
import classNames from "classnames";
import { isMobile } from "@/utils";

const { Paragraph } = Typography;
const NewsCard = ({
  img,
  title,
  date,
  link,
}: {
  img: string;
  title: string;
  date: string;
  link: string;
  index: number;
  length: number;
}) => {
  return (
    <div className={styles.newsCard} onClick={() => window.open(link, '_blank')}>
      <div className={styles.img}>
        <img src={img} alt={title} />
      </div>
      <Paragraph
        ellipsis={{
          tooltip: title,
          rows: 2,
          expandable: false,
        }}
        className={styles.title}
      >
        {title}
      </Paragraph>
      <div className={styles.date}>{date}</div>
    </div>
  );
};
const NewsList = ({list}:{
  list: Array<{
    img: string;
    title: string;
    date: string;
    link: string;
  }>;
}) => {
  return (
    <div className={classNames(styles.newsList, {
      [styles.isMobile]: isMobile()
    })}>
      {list.map((item, index) => (
        <NewsCard key={item.link} {...item} index={index} length={list.length} />
      ))}
    </div>
  );
};
export default NewsList;
